<template>
  <div>
    Case info page {{ $route.params.caseId }}
    <!-- todo(TECH-325): implement -->
  </div>
</template>

<script>
    export default {
        name: 'case-info-page',
        props: {
        },
        data () {
            return {}
        },
        computed: {
        },
        mounted () {

        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/cases/CaseIndexPage.vue